<template>
  <div>
    <cube-cascade-picker
      :alias="{ value: 'code', text: 'name'}"
      :data="cascadeData"
      :visible="visible"
      @cancel="cancel"
      @select="select"
    ></cube-cascade-picker>
  </div>
</template>
<script>
export default {
  name: 'vAddress',
  data() {
    return {
      cascadeData: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    appendToBody:{
      type: Boolean,
      default: true
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.appendToBody) {
          document.body.appendChild(this.$el)
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    select(selectedVal, selectedIndex, selectedText) {
      this.$emit('select', [selectedText, selectedVal])
    },
    getAddress() {
      this.$groupGet('user/web/common/getAddress').then(data => {
        if (data.errCode == 0) {
          const arr = data.data
          for (var i = 0; i < data.data.length; i++) {
            arr[i].children = arr[i].cityList
            for (var j = 0; j < arr[i].cityList.length; j++) {
              arr[i].cityList[j].children = arr[i].cityList[j].districtList
            }
          }
          this.cascadeData = arr
        }
      })
    },
  },
  created() {},
  mounted() {
    this.getAddress()
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/group/components/address/address.vue